<template>
    <div>
        <div class="vue-modal cover flex flex-center">
            <div class="row pop-up" :style="{ background: background, width: width, height: height, maxWidth: maxWidth, maxHeight: maxHeight }">
                <header v-if="!hideClose">
                    <div class="close" @click.stop="hideModal">
                        <RemovalX></RemovalX>
                    </div>
                </header>
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import RemovalX from "./icons/removal-x.vue";

    export default {
        components: {
            RemovalX,
        },
        props: {
            background: {
                type: String,
                default: "white",
                required: false,
            },
            width: {
                type: String,
                default: "90%",
                required: false,
            },
            maxWidth: {
                type: String,
                default: "90%",
                required: false,
            },
            maxHeight: {
                type: String,
                default: "90%",
                required: false,
            },
            height: {
                type: String,
                default: "85%",
                required: false,
            },
            customStyle: {
                type: String,
                required: false,
            },

            hideClose: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        data() {
                return {
                }
        },

        methods: {
            hideModal() {
                this.$emit("hide-modal");
            },
        },
    }
</script>

<style scoped>

    .flex {
        display: flex;
    }

    .flex-center {
        align-items: center;
        justify-content: center;
    }

    .flex-around {
        align-items: center;
        justify-content: space-around;
    }

    .vue-modal {
        font-family: "Nitti Grotesk", sans-serif;
        font-style: normal;
        font-weight: normal;
    }

    /* Add animation (fade in the pop-up) */
    @-webkit-keyframes fadeIn {
        from {opacity: 0;}
        to {opacity: 1;}
        from {visibility: hidden;}
        to {visibility: visible;}
    }

    @keyframes fadeIn {
        from {opacity: 0;}
        to {opacity:1 ;}
        from {visibility: hidden;}
        to {visibility: visible;}
    }

    .cover {
        width:100%;
        height:100%;
        top:0;
        left:0;
        position: fixed;
        background:rgba(0,0,0,0.5);
        z-index: 10000;
    }

    .pop-up {
        background-color: white;
        border-radius: 8px;
        overflow-x: auto;
        overflow-y: auto;
        padding: 15px;
        visibility: visible;
        position: relative;
        -webkit-animation: fadeIn 0.7s;
        animation: fadeIn 0.7s;
    }

    header {
        width: 100%;
    }

    .close {
        min-height: 32px;
        display: flex;
        justify-items: end;
        flex-direction: row-reverse;
        opacity: 1;
    }
</style>